import { render } from "./AttrData.vue?vue&type=template&id=02700f40&scoped=true"
import script from "./AttrData.vue?vue&type=script&lang=js"
export * from "./AttrData.vue?vue&type=script&lang=js"

import "./AttrData.vue?vue&type=style&index=0&id=02700f40&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02700f40"]])

export default __exports__